import React from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "@apollo/client";

import { AuthContext } from "contexts/authContext";

import { useLocalUserInfo } from "hooks/useLocalUserInfo";

import { REVOKE_TOKEN } from "graphqlQueries/auth";

import {
  setAuthInfoToStorage,
  clearAuthInfoFromLocalStorage,
  getRefreshTokenFromStorage,
} from "utils/jwtUtils";

const AuthProvider = ({ children }) => {
  const [userInfo] = useLocalUserInfo({});

  const client = useApolloClient();

  const signIn = async (authInfo) => {
    setAuthInfoToStorage(authInfo);
  };

  const signOut = async () => {
    const refreshToken = getRefreshTokenFromStorage();
    await client.mutate({
      mutation: REVOKE_TOKEN,
      variables: { refresh_token: refreshToken },
    });

    await client.clearStore();
    clearAuthInfoFromLocalStorage();
  };

  return (
    <AuthContext value={{ ...userInfo, signIn, signOut }}>
      {children}
    </AuthContext>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AuthProvider;
